import { TextWithTranslationsT } from '../types';
import { FORM_COMPONENT_BASIC_INPUT_TYPE } from './formComponentInputTypeSchema';
import { COMPONENT_FIELDS } from './formComponentFieldSchema';
import { ComponentFieldsT, FormComponentBasicInputTypeT } from './types';

export const COMPONENT_INPUT_TYPE_LABEL_TRANSLATIONS: Record<FormComponentBasicInputTypeT, TextWithTranslationsT> = {
  [FORM_COMPONENT_BASIC_INPUT_TYPE.text]: { en: 'Text', fr: 'Texte' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.info]: { en: 'Info', fr: 'Info' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.number]: { en: 'Number', fr: 'Nombre' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.date]: { en: 'Date', fr: 'Date' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.time]: { en: 'Time', fr: 'Heure' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.phone]: { en: 'Phone', fr: 'Telephone' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.yesNo]: { en: 'Yes/No', fr: 'Oui/Non' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.checkbox]: { en: 'Multiple Choice', fr: 'Choix multiples' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.radio]: { en: 'Single Choice', fr: 'Choix unique' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.image]: { en: 'Image', fr: 'Image' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.file]: { en: 'File', fr: 'Fichier' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.link]: { en: 'Link', fr: 'Lien' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.button]: { en: 'Button', fr: 'Bouton' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.singleCheckbox]: { en: 'Checkbox', fr: 'case à cocher' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.documentReview]: { en: 'Document Review', fr: 'Examen des documents' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.checkboxDisable]: { en: 'Checkbox Disable', fr: 'Case à cocher désactivée' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.sin]: { en: 'Social Insurance Number', fr: 'Numéro d’assurance sociale' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.ssn]: { en: 'Social Security Number', fr: 'Numéro de securité sociale' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.signature]: { en: 'Signature', fr: 'Signature' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.bankAccountNumber]: { en: 'Bank Account Number', fr: 'Numéro de compte bancaire' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.routingNumber]: { en: 'Routing Number', fr: 'Numéro d’acheminement' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.branchTransitNumber]: { en: 'Branch Transit Number', fr: 'Numéro de transit de l’agence' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.financialInstitutionNumber]: {
    en: 'Financial Institution Number',
    fr: 'Numéro de l’institut financier',
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.correspondenceLanguage]: { en: 'Correspondence Language', fr: 'Langue de correspondance' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.gender]: { en: 'Gender', fr: 'Sexe' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.email]: { en: 'Email', fr: 'Email' },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.address]: { en: 'Address', fr: 'Adresse' },
} as const;

export const COMPONENT_FIELD_LABEL_TRANSLATIONS: Record<ComponentFieldsT, TextWithTranslationsT> = {
  [COMPONENT_FIELDS.name]: { en: 'Name', fr: 'Nom' },
  [COMPONENT_FIELDS.dateOfBirth]: { en: 'Date of Birth', fr: 'Date de naissance' },
  [COMPONENT_FIELDS.phoneNumber]: { en: 'Phone Number', fr: 'Numéro de téléphone' },
  [COMPONENT_FIELDS.optionalPhoneNumber]: { en: 'Optional Phone Number', fr: 'Numéro de téléphone facultatif' },
  [COMPONENT_FIELDS.socialInsuranceNumber]: { en: 'Social Insurance Number', fr: 'Numéro d’assurance sociale' },
  [COMPONENT_FIELDS.socialSecurityNumber]: { en: 'Social Security Number', fr: 'Numéro de securité sociale' },
  [COMPONENT_FIELDS.completeAddress]: { en: 'Complete Address', fr: 'Adresse complète' },
  [COMPONENT_FIELDS.apartment]: { en: 'Apartment', fr: 'Appartement' },
  [COMPONENT_FIELDS.emergencyContact]: { en: 'Emergency Contact', fr: 'Contact d’urgence' },
  [COMPONENT_FIELDS.signatureImageUrl]: { en: 'Signature', fr: 'Signature' },
  [COMPONENT_FIELDS.chequebookImageUrl]: { en: 'Cheque', fr: 'Chèque' },
  [COMPONENT_FIELDS.workPermitImageUrl]: { en: 'Work Permit', fr: 'Permis de travail' },
  [COMPONENT_FIELDS.workPermitEndDate]: { en: 'Work Permit End Date', fr: 'Date de fin du permis de travail' },
  [COMPONENT_FIELDS.documentIdImageUrl]: { en: 'Document Image', fr: 'Image du document' },
  [COMPONENT_FIELDS.firstName]: { en: 'First Name', fr: 'Prénom' },
  [COMPONENT_FIELDS.middleName]: { en: 'Middle Name', fr: 'Deuxième prénom' },
  [COMPONENT_FIELDS.lastName]: { en: 'Last Name', fr: 'Nom de famille' },
  [COMPONENT_FIELDS.nickname]: { en: 'Nickname', fr: 'Pseudo' },
  [COMPONENT_FIELDS.addressLineOne]: { en: 'Address Line 1', fr: 'Ligne d’adresse 1' },
  [COMPONENT_FIELDS.addressLineTwo]: { en: 'Address Line 2', fr: 'Ligne d’adresse 2' },
  [COMPONENT_FIELDS.city]: { en: 'City', fr: 'Ville' },
  [COMPONENT_FIELDS.region]: { en: 'Region', fr: 'Région' },
  [COMPONENT_FIELDS.postalCode]: { en: 'Postal Code', fr: 'Code postal' },
  [COMPONENT_FIELDS.country]: { en: 'Country', fr: 'Pays' },
  [COMPONENT_FIELDS.contractDetailsWordings]: { en: 'Contract Details Wordings', fr: 'Libellés des détails du contrat' },
  [COMPONENT_FIELDS.emergencyContactFirstName]: { en: 'Emergency Contact First Name', fr: 'Prénom du contact d’urgence' },
  [COMPONENT_FIELDS.emergencyContactLastName]: { en: 'Emergency Contact Last Name', fr: 'Nom de famille du contact d’urgence' },
  [COMPONENT_FIELDS.emergencyContactPhoneNumber]: {
    en: 'Emergency Contact Phone Number',
    fr: 'Numéro de téléphone du contact d’urgence',
  },
  [COMPONENT_FIELDS.endDate]: { en: 'End Date', fr: 'Date de fin' },
  [COMPONENT_FIELDS.codeofconductandethics]: { en: 'Code of Conduct and Ethics', fr: 'Code de conduite et d’ethique' },
  [COMPONENT_FIELDS.privacynoticeforemployees]: {
    en: 'Privacy Notice for Employees',
    fr: 'Avis de confidentialité pour les employés',
  },
  [COMPONENT_FIELDS.electronicmonitoringpolicy]: {
    en: 'Electronic Monitoring Policy',
    fr: 'Politique de surveillance électronique',
  },
  [COMPONENT_FIELDS.bankAccountNumber]: { en: 'Bank Account Number', fr: 'Numéro de compte bancaire' },
  [COMPONENT_FIELDS.routingNumber]: { en: 'Routing Number', fr: 'Numéro d’acheminement' },
  [COMPONENT_FIELDS.branchTransitNumber]: { en: 'Branch Transit Number', fr: 'Numéro de transit de l’agence' },
  [COMPONENT_FIELDS.financialInstitutionNumber]: { en: 'Financial Institution Number', fr: 'Numéro de l’institut financier' },
  [COMPONENT_FIELDS.correspondenceLanguage]: { en: 'Correspondence Language', fr: 'Langue de correspondance' },
  [COMPONENT_FIELDS.gender]: { en: 'Gender', fr: 'Genre' },
  [COMPONENT_FIELDS.email]: { en: 'Email', fr: 'Courriel' },
  [COMPONENT_FIELDS.address]: { en: 'Address', fr: 'Adresse' },
  [COMPONENT_FIELDS.earliestAvailabilityDate]: { en: 'Earliest Availability Date', fr: 'Date de disponibilité la plus proche' },
  [COMPONENT_FIELDS.workPermitType]: { en: 'Work Permit Type', fr: 'Type de permis de travail' },
  [COMPONENT_FIELDS.signature]: { en: 'Signature', fr: 'Signature' },
  [COMPONENT_FIELDS.legalFirstName]: { en: 'Legal First Name', fr: 'Prénom juridique' },
  [COMPONENT_FIELDS.legalMiddleName]: { en: 'Legal Middle Name', fr: 'Deuxième prénom juridique' },
  [COMPONENT_FIELDS.legalLastName]: { en: 'Legal Last Name', fr: 'Nom de famille juridique' },
} as const;

export const COMPONENT_FIELD_LABEL = {
  ...COMPONENT_INPUT_TYPE_LABEL_TRANSLATIONS,
  ...COMPONENT_FIELD_LABEL_TRANSLATIONS,
} as const;
